import Vue from "vue";
import ApiService from "@/common/api.service";
import { API_PATH } from "@/common/config";

const PATH = "incoterms";

// action types
export const GET_INCOTERMS = "getIncoterms";
export const GET_INCOTERM = "getIncoterm";
export const GET_INCOTERM_OPTIONS = "getIncotermOptions";
export const STORE_INCOTERM = "storeIncoterm";
export const UPDATE_INCOTERM = "updateIncoterm";
export const DELETE_INCOTERM = "deleteIncoterm";

// mutation types
export const SET_INCOTERMS_LOADING = "setIncotermsLoading";

const state = {
  incotermsLoading: false
};

const getters = {
  incotermsLoading(state) {
    return state.incotermsLoading;
  }
};

const actions = {
  [GET_INCOTERMS](context, params) {
    // Settings listing uses paginated apiResource index.
    // Consumers with no params still hit /incoterms/index.
    if (params === undefined) {
      return new Promise((resolve, reject) => {
        ApiService.get(`${PATH}/index`)
          .then(({ data }) => {
            resolve(data.data);
          })
          .catch(({ response }) => {
            reject(response.data);
          });
      });
    }

    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [GET_INCOTERM](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [GET_INCOTERM_OPTIONS](context) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, "options")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [STORE_INCOTERM](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [UPDATE_INCOTERM](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, params.id, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [DELETE_INCOTERM](context, id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(`${API_PATH}${PATH}/${id}`)
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error?.response?.data ?? error);
        });
    });
  },
};

const mutations = {
  [SET_INCOTERMS_LOADING](state, value) {
    state.incotermsLoading = value;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
